import { useParams } from "react-router-dom";

import { useGetAllRFQQuery } from "../../store/apiSlices/adminApi";

import { RFQCard } from "../../components/Admin/CustomerRFQsDetails/RFQCard";
import { useRef, useState } from "react";
import Modal from "../../components/Modal";
import { BellRingIcon } from "../../components/Icons";
import { CreateInvoice } from "../../components/Admin/QuotesDetails/CreateInvoice";

export default function CustomerOngoingQuotesDetails() {
  const { uid, id } = useParams();
  const { data: rfqs, isLoading } = useGetAllRFQQuery({ uid: Number(uid) });

  const quote = rfqs?.find(
    (el) => el?.id === Number(id) || el?.quotes_id === id,
  );

  if (isLoading)
    return (
      <div className="p-10 text-center text-gray-500 text-sm">
        Loading company details...
      </div>
    );

  if (!quote)
    return (
      <div className="p-10 text-center text-gray-500 text-sm">
        No quote found.
      </div>
    );

  return (
    <section className="bg-white shadow-sm rounded-lg p-6 space-y-6 border border-gray-200">
      <h3 className="text-lg font-medium text-blue-700 capitalize">
        Logistics Ongoing Quotes
      </h3>

      <RFQCard key={quote.id} quote={quote}>
        <RFQCard.Header />

        <RFQCard.SubInfo />

        <RFQCard.Meta>
          {quote.pickup_date && (
            <span>
              <span className="font-medium text-gray-600">Pickup:</span>{" "}
              {quote.pickup_date}
            </span>
          )}

          {quote.incoterm && (
            <span className="px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 font-medium">
              {quote.incoterm}
            </span>
          )}

          {quote.goods_category && (
            <span className="truncate max-w-full">
              <span className="font-medium text-gray-600">Goods:</span>{" "}
              {quote.goods_category}
            </span>
          )}
        </RFQCard.Meta>

        <RFQCard.Footer />

        <RFQCard.ConfirmedQuote />
        <RFQCard.CompleteTransactionButton />
      </RFQCard>

      <hr className="mb-4 mt-10" />

      <div className="grid grid-cols-3 pb-5">
        <ActionCustomerTasks />
        <DocumentsVault />
        <Invoices />
      </div>
    </section>
  );
}

function ActionCustomerTasks() {
  const tasks = [
    { task: "Add Packing List", notified: true },
    { task: "Awaiting Logistics Quote Approval", notified: false },
    { task: "Supplier audit: Need Docs", notified: false },
    { task: "Credit Check: Financial statements", notified: false },
    { task: "Select loading Inspection Quotes", notified: false },
  ];
  return (
    <section className="p-2">
      <div className="flex justify-between items-center pb-4">
        <h2 className="text-lg">Active Customer Tasks</h2>
        <button className="border px-2 py-1 rounded-md border-custom-blue">
          <p className="text-custom-blue text-sm">Add Custom Tasks</p>
        </button>
      </div>
      {tasks.map((el, i) => (
        <div key={i} className="flex justify-between items-center p-2">
          <p className="text-sm">{el.task}</p>
          <span>
            <BellRingIcon className="text-slate-800 w-[10px]" />
          </span>
        </div>
      ))}
    </section>
  );
}

function DocumentsVault() {
  const tasks = [
    { task: "Add Packing List", notified: true },
    { task: "Awaiting Logistics Quote Approval", notified: false },
    { task: "Supplier audit: Need Docs", notified: false },
    { task: "Credit Check: Financial statements", notified: false },
    { task: "Select loading Inspection Quotes", notified: false },
  ];
  return (
    <section className="p-2 border-l-2 border-r-2">
      <div className="flex justify-between items-center pb-4">
        <h2 className="text-lg">Documents Vault</h2>
        <button className="border px-2 py-1 rounded-md border-custom-blue">
          <p className="text-custom-blue text-sm">Request Documents</p>
        </button>
      </div>
      {tasks.map((el, i) => (
        <div key={i} className="flex justify-between p-2 items-center">
          <p className="text-sm">{el.task}</p>
          <span>
            <p className="text-xs hidden hover:block cursor-pointer border border-custom-blue rounded-md px-2 text-custom-blue">
              View
            </p>
          </span>
        </div>
      ))}
    </section>
  );
}

function Invoices() {
  const invoiceRef = useRef<HTMLDialogElement>(null);
  const [modalContent, setModalContent] = useState<React.ReactNode>(false);

  const toggleModal = () => {
    const currentNode = invoiceRef.current;

    if (!currentNode) return;

    if (currentNode.open) {
      currentNode.close();
      setModalContent(null);
    } else {
      currentNode.showModal();
      setModalContent(
        <>
          <h2 className="text-2xl text-right uppercase mt-10 pr-10 font-semibold text-gray-800 mb-2">
            Invoice
          </h2>
          <CreateInvoice toggleDialog={toggleModal} />
        </>,
      );
    }
  };
  const tasks = [
    { task: "Invoice Factoring Bill", notified: true },
    { task: "Logistics Invoice", notified: false },
    { task: "Quality Assurance Invoice", notified: false },
    { task: "Insurance Invoice", notified: false },
    { task: "Custom Clearance Invoice", notified: false },
  ];
  return (
    <section className="p-2">
      <div className="flex justify-between items-center pb-4">
        <h2 className="text-lg">Invoice/ Billing</h2>
        <button
          onClick={toggleModal}
          className="border px-2 py-1 rounded-md border-custom-blue"
        >
          <p className="text-custom-blue text-sm">Create Invoice</p>
        </button>
      </div>
      {tasks.map((el, i) => (
        <div key={i} className="flex justify-between p-2 items-center">
          <p className="text-sm">{el.task}</p>
        </div>
      ))}
      <Modal
        ref={invoiceRef}
        toggleDialog={toggleModal}
        className={
          "overflow-y-auto max-w-5xl p-6 rounded-2xl bg-white shadow-2xl overflow-visible backdrop:bg-black/30"
        }
      >
        {modalContent}
      </Modal>
    </section>
  );
}
